import { useEffect } from 'react';
import { useMessage } from '../contexts/MessageContext';

const NetworkStatus = () => {
  const { error, warning, info } = useMessage();

  useEffect(() => {
    // 监听网络状态变化
    const handleOnline = () => {
      info('Network connection restored');
      console.log('🌐 Network connection restored');
    };

    const handleOffline = () => {
      warning('Network connection lost. Please check your internet.');
      console.log('📡 Network connection lost');
    };

    // 添加事件监听器
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // 检查初始网络状态
    if (!navigator.onLine) {
      warning('No internet connection detected');
    }

    // 清理事件监听器
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [error, warning, info]);

  // 监听页面可见性变化（用户切换标签页时）
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === 'visible' && !navigator.onLine) {
        warning('No internet connection');
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [warning]);

  return null; // 这是一个无UI的组件
};

export default NetworkStatus;
